import Shimmer from "@/components/Shimmer";

const ComplianceReportLoading = () => (
  <div
    className="mt-30 flex flex-col gap-30"
    data-testid="compliance-report-loading">
    <Shimmer height="660px" rounded="sm" />
    <div className="rounded-sm">
      <Shimmer height="80px" rounded="sm" />
    </div>
    <div className="rounded-sm">
      <Shimmer height="80px" rounded="sm" />
    </div>
    <div className="rounded-sm">
      <Shimmer height="80px" rounded="sm" />
    </div>
    <div className="rounded-sm">
      <Shimmer height="590px" rounded="sm" />
    </div>
  </div>
);

export default ComplianceReportLoading;
